<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">star</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Definir como padrão</h2>
    <span class="modal-subtitle">Marque os tipos de padrão desta natureza</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <p class="subtitle">
    Natureza: <br>
    <strong>{{ data.natureza.nome }}</strong>
  </p>

  <div class="option-list" role="group" aria-label="Tipos de padrão">
    @for (tipoPadrao of tiposPadraoDisponiveis; track tipoPadrao.idTipoPadraoNaturezaOperacao) {
      <button
        type="button"
        class="action-card-action"
        role="checkbox"
        [attr.aria-checked]="isSelecionado(tipoPadrao)"
        (click)="alternar(tipoPadrao)">
        <app-action-card
          [title]="tipoPadrao.nome"
          [description]="tipoPadrao.descricao"
          [icon]="tipoPadraoIcones[tipoPadrao.idTipoPadraoNaturezaOperacao] || 'star'"
          [interactive]="true"
          [selected]="isSelecionado(tipoPadrao)">
          @if (nomeNaturezaAtual(tipoPadrao); as atual) {
            <span class="natureza-atual">Hoje: {{ atual }}</span>
          }
          <mat-icon cardActions class="material-symbols-outlined" aria-hidden="true">
            {{ isSelecionado(tipoPadrao) ? 'check_circle' : 'circle' }}
          </mat-icon>
        </app-action-card>
      </button>
    }
  </div>

  @if (avisos.length > 0) {
    <app-alert-card type="warning">
      @for (aviso of avisos; track aviso) {
        <p class="aviso-padrao">{{ aviso }}</p>
      }
    </app-alert-card>
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <span [matTooltip]="podeConfirmar ? '' : 'Marque ou desmarque um tipo de padrão para salvar.'">
    <button mat-flat-button class="btn-primary" [disabled]="!podeConfirmar" (click)="salvar()">Salvar padrões</button>
  </span>
</mat-dialog-actions>
